import React, { Component, Fragment } from 'react'

import moment from 'moment'
import {
  DatePicker,
  Layout,
  Breadcrumb,
  Form,
  Input,
  Divider,
  Row,
  Col,
  Avatar,
  Select,
  Switch,
  Tag,
  Icon,
  Button,
  Checkbox,
  message,
  notification,
  Skeleton,
  Popover,
  Radio,
  Spin,
  Tabs,
  InputNumber,
  List,
  Card,
  Modal,
} from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from '@ant-design/icons'
// import styles from './styles.module.scss';
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import Errors from 'validatorjs/src/errors'
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert'
import CitySelect from 'components/CitySelect/CitySelect'
import { genFormItemAtrribute } from 'libs/FormHelper'
import { RadioControl, CheckboxControl } from '@wordpress/components'
import { withState } from '@wordpress/compose'
import bannerImage from 'assets/img/banner/banner-catalog.png'
import { store } from '../../reducers'
import { updateAuthInfo } from '../../reducers/auth'
import { UploadOutlined } from '@ant-design/icons'
import WUpload from 'components/WUpload/WUpload'
import { __ } from '@wordpress/i18n'

const VC_CONFIG = window.VC_CONFIG
const Local = _.get(window, 'VC_CONFIG.Locale')

const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
// 前端頁面
export default class UserPoint extends Component {
  formRef = React.createRef()
  state = {
    query: {},
    listInfo: _.cloneDeep(defaultListInfo),
    tableData: [],
    selectmonth: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    isLoading: true,
  }

  componentDidMount() {
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    const query = {
      start_dt: moment(firstDay).format('YYYY-MM-DD'),
      end_dt: moment(lastDay).format('YYYY-MM-DD'),
    }
    // AppHelper.updateConfig()
    this.setState({ query })
    this.setState({ info: this.props.user }, () => {
      this.reloadTab()
    })
    this.loadData(query)
    // AppHelper.updateUserInfo(() => {

    //   this.setState({ isFetchData: false })

    //   this.fillData(this.props.user)
    // });

    // 登入換 tokne
    //http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
    // 電子發票列表
    // http://{{hostip}}//api/account/eInvoiceList
    // 點數紀錄 / 消費記錄
    // 密碼變更
    // 查詢編輯會員資料
    // 查詢好康卡會員資料
  }
  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      console.log('kkk c', $magicLine)
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }
  loadData = (query = {}) => {
    console.log('loadData', query)
    //const { query } = this.state;
    const { page, page_size } = { page: 1, page_size: 'all' }

    this.setState({ isLoadingData: true })

    whttp.post(
      API_HOST + '/api/account/eInvoiceList',
      {
        start_dt: query.start_dt,
        end_dt: query.end_dt,
      },
      (state, res) => {
        this.setState({ isLoadingData: false })
        console.log('333333333333333333333333')
        const { code = 100, reason = '發生錯誤', data = {} } = res
        console.log(code, reason, data, res)
        console.log('1111111111111111111', state)
        if (state === false) {
          return console.log('55555555555555555555')
        } //this.setState({ message: '發生錯誤' }); }

        if (code !== 200) {
          return console.log('66666666666666666666')
        } //this.setState({ message: reason }); }
        console.log('eInvoiceList_data', data)
        this.setState({ tableData: data.einvoices }, () => {
          this.refreshPicker()
        })
      }
    )
  }
  fillData = (data = {}) => {
    if (!this.formRef.current) return

    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.address) || !_.isObject(data.address)) {
      data.address = {
        city_id: _.get(data, 'city_id'),
        area_id: _.get(data, 'area_id'),
      }
    }

    console.log('filldata', data)
    this.formRef.current.setFieldsValue(data)
    this.setState({ isLoading: false }, () => {
      this.reloadTab()
    })
  }

  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh')
  }, 1000)

  wincode = (num) => {
    var codeA = '特別獎 1000萬'
    var codeB = '千元獎 2000元'
    var codeC = '百萬獎 100萬'
    var code = [
      '特　獎 200萬',
      '頭　獎 20萬',
      '二　獎 <br> 4萬',
      '三　獎 <br> 1萬',
      '四　獎 4,000元',
      '五　獎 1,000元',
      '六　獎 200元',
    ]
    if (num === 'A') {
      return codeA || '??'
    } else if (num === 'B') {
      return codeB || '??'
    } else if (num === 'C') {
      return codeC || '??'
    } else {
      num = parseInt(num, 10)
      return code[num] || '??'
    }
  }
  nonwincode = (date) => {
    if (date) {
      var getDate = moment(date)
      var currDate = moment()
      if (moment(getDate).isBefore(currDate)) {
        var getDateMonth = getDate.format('M')
        var currDateMonth = currDate.format('M')
        var currDateDay = currDate.format('D')
        var diffMonth = Math.abs(currDateMonth - getDateMonth)

        if (currDateMonth >= 7) {
          //7-12月
          if (diffMonth > 2) {
            if (localStorage.getItem('setlang') == 'en') {
              return "Didn't win a Prize"
            } else {
              return '未中獎'
            }
          } else {
            if (currDateMonth % 2 == 0) {
              //偶數月
              if (diffMonth > 1) {
                if (localStorage.getItem('setlang') == 'en') {
                  return "Didn't win a Prize"
                } else {
                  return '未中獎'
                }
              } else {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              }
            } else {
              //開獎月(奇數月)
              if (diffMonth == 0) {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              } else {
                if (currDateDay > 25) {
                  // 已開獎
                  if (localStorage.getItem('setlang') == 'en') {
                    return "Didn't win a Prize"
                  } else {
                    return '未中獎'
                  }
                } else {
                  if (localStorage.getItem('setlang') == 'en') {
                    return '未開獎'
                  } else {
                    return '未開獎'
                  }
                }
              }
            }
          }
        } else {
          if (diffMonth > 2 && diffMonth < 10) {
            if (localStorage.getItem('setlang') == 'en') {
              return "Didn't win a Prize"
            } else {
              return '未中獎'
            }
          } else {
            if (currDateMonth % 2 == 0) {
              //偶數月
              if (diffMonth <= 1) {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              } else {
                if (localStorage.getItem('setlang') == 'en') {
                  return "Didn't win a Prize"
                } else {
                  return '未中獎'
                }
              }
            } else {
              //開獎月(奇數月)
              if (diffMonth == 0) {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              } else {
                if (currDateDay > 25) {
                  // 已開獎
                  if (localStorage.getItem('setlang') == 'en') {
                    return "Didn't win a Prize"
                  } else {
                    return '未中獎'
                  }
                } else {
                  if (localStorage.getItem('setlang') == 'en') {
                    return '未開獎'
                  } else {
                    return '未開獎'
                  }
                }
              }
            }
          }
        }
      } else {
        if (localStorage.getItem('setlang') == 'en') {
          return '無法判斷'
        } else {
          return '無法判斷'
        }
      }
    } else {
      if (localStorage.getItem('setlang') == 'en') {
        return '無法判斷'
      } else {
        return '無法判斷'
      }
    }
  }

  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors())
    const options = _.get(this, 'props.app.options', {})
    const { query, info, tableData = [] } = this.state
    var tmpstatus = ''
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    var tmpStr_area = '',
      tmpResult_area =
        '<option value="' +
        moment(firstDay).format('YYYY-MM-DD') +
        '">' +
        moment(firstDay).format('YYYY年MM月') +
        '</option>'
    for (var i = 0; i < 5; i++) {
      tmpStr_area =
        '<option value="' +
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY-MM-DD') +
        '">' +
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY年MM月') +
        '</option>'
      tmpResult_area = tmpResult_area + tmpStr_area
      firstDay = moment(firstDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
      lastDay = moment(lastDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
    }
    console.log('option', tmpResult_area)
    $('#SelectMonth').html(tmpResult_area)
    this.refreshPicker()
    return (
      <div>
        <main className='bg-light'>
          <div className='container'>
            <section className='pt-2 pb-2'>
              <div className='breadcrumb-wrap'>
                <nav aria-label='breadcrumb'>
                  {Local == 'zh_TW' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('電子發票紀錄', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                  {Local == 'en_US' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/en`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('電子發票紀錄', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                </nav>
              </div>
              <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                {__('親愛的', 'cec-plugin-stores')}{' '}
                <b className='fw-700'>{info && info.cn_name}</b>
                <br className='d-block d-lg-none' />
                {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
              </h6>
            </section>
          </div>
          <section className='pt-0'>
            <div className='mb-5 basic-tabs-label'>
              {Local == 'zh_TW' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${VC_CONFIG.INDEX_URL}/pwd`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link '
                      href={`${VC_CONFIG.INDEX_URL}/payment`}
                    >
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/point`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/connect`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
              {Local == 'en_US' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${VC_CONFIG.INDEX_URL}/pwd-en`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile-en`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link '
                      href={`${VC_CONFIG.INDEX_URL}/payment-en`}>
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/point-en`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/connect-en`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
            </div>

            <div className='container'>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <div className='row justify-content-center'>
                        <div className='col-6 col-lg-9'>
                          <h5 className='h4 text-navy text-center mb-0'>
                            {__('查詢月份', 'cec-plugin-stores')}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <div className='row'>
                        <div className='col-sm-4'>
                          <select
                            className='form-select selectpicker'
                            name='SelectMonth'
                            id='SelectMonth'
                            value={this.state.selectmonth}
                            onChange={(e) => {
                              query.start_dt = e.target.value
                              query.end_dt = moment(e.target.value)
                                .endOf('month')
                                .format('YYYY-MM-DD')
                              this.loadData(query)
                              this.setState({ selectmonth: e.target.value })
                              console.log('1111', this.state.selectmonth)
                            }}
                          />
                        </div>
                        <div className='col-sm-8'>
                          <p className='h6 text-navy fw-700 mb-2'>
                            {__(
                              '網站僅提供六個月內消費記錄查詢, 若您對您的消費記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！',
                              'cec-plugin-stores',
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-12 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5 p-lg-0'>
                      <div className='flex-table' data-theme='success'>
                        <div className='thead'>
                          <ul className='table-row'>
                            <li>{__('消費日期', 'cec-plugin-stores')}</li>
                            <li>{__('發票號碼', 'cec-plugin-stores')}</li>
                            <li>
                              {__('是否列印發票', 'cec-plugin-stores')}
                            </li>
                            <li>{__('發票捐贈', 'cec-plugin-stores')}</li>
                            <li>{__('是否中獎', 'cec-plugin-stores')}</li>
                          </ul>
                        </div>
                        <div className='tbody'>
                          {tableData.length == 0 && (
                            <ul className='table-row'>
                              <li data-title='消費日期'>
                                {__(
                                  '尚無任何消費記錄',
                                  'cec-plugin-stores',
                                )}
                              </li>
                            </ul>
                          )}
                          {_.map(tableData, (v) => {
                            return (
                              <ul className='table-row'>
                                <li data-title='消費日期'>{v.inv_date}</li>
                                <li data-title='發票號碼'>{v.inv_code}</li>
                                <li data-title='是否列印發票'>
                                  {v.inv_type == '電子發票(有列印)'
                                    ? __('非歸戶發票', 'cec-plugin-stores')
                                    : __(
                                        '電子發票(無列印)',
                                        'cec-plugin-stores',
                                      )}
                                </li>
                                <li data-title='發票捐贈'>
                                  {v.don_fl == 1
                                    ? __('捐贈', 'cec-plugin-stores')
                                    : __('無', 'cec-plugin-stores')}
                                </li>
                                <li data-title='是否中獎'>
                                  {v.inv_win_flag == 1 &&
                                    v.inv_type ==
                                      __(
                                        '電子發票(無列印)',
                                        'cec-plugin-stores',
                                      ) &&
                                    this.wincode(v.inv_win_code)}
                                  {v.inv_win_flag == 0 &&
                                    v.inv_type ==
                                      __(
                                        '電子發票(無列印)',
                                        'cec-plugin-stores',
                                      ) &&
                                    this.nonwincode(v.inv_date)}
                                  {v.inv_type ==
                                    __(
                                      '電子發票(有列印)',
                                      'cec-plugin-stores',
                                    ) &&
                                    __(
                                      '非歸戶發票自行兌獎',
                                      'cec-plugin-stores',
                                    )}
                                </li>
                              </ul>
                            )
                          })}
                        </div>
                      </div>
                      {/* <div className="text-center mt-5 my-lg-5"><a className="h6 btn btn-success rounded-pill px-5 py-2 mb-0" role="button" href="#">看更多</a></div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div class='row no-gutters mx-n3 mb-4'>
                <div class='col-lg-6 px-3'>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body p-5'>
                      <h5 class='h3 text-navy text-center mb-4'>
                        {__('電子發票歸戶', 'cec-plugin-stores')}
                      </h5>
                      <div class='row'>
                        <div class='col-8 col-md-6 mx-auto'>
                          {/* <a class="h6 btn btn-block btn-outline-primary rounded-pill py-4" role="button" href={info && `https://account.uni-prosperity.com.tw/einvoice/cards?gid=${info.gid}`} target="_blank">{__('開始歸戶','cec-plugin-stores')}</a> */}
                          <a
                            class='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                            role='button'
                            href='#'
                            onClick={(e) => {
                              Modal.error({
                                title: 'Oops! 發票歸戶功能維修中',
                                content:
                                  '即日至10/27，將暫停設定會員發票歸戶功能，造成不便敬請見諒。',
                              })
                            }}>
                            {__('開始歸戶', 'cec-plugin-stores')}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='col-lg-6 px-3'>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body p-5'>
                      <p class='h6 text-navy text-justify mb-0'>
                        {__(
                          '由於財政部電子發票服務平台建議使用IE8.0以上的瀏覽 器來進行歸戶，因此建議您不要使用平板電腦來進行好 康卡及聯名卡的歸戶作業，感謝您的配合，謝謝！',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <h5 className='h4 text-navy text-center'>
                        {__('注意事項', 'cec-plugin-stores')}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '客服中心：市話 0809-001-365 / 手機(02)8006-9999 ',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserInvoiceEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)

    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-users-invoice-editor'>
        <h2>會員點數記錄模組</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-invoice.js